import React from "react";

export default function Footer() {
  return (
    <footer className="bg-white">
      {/* Main content */}
      <div className="px-10 md:px-16 lg:px-24 xl:px-40 pt-16 sm:pt-16 lg:pt-24 pb-[16px]">
        <div className="max-w-[1400px] mx-auto">
          {/* Initiative description */}
          <p className="font-inter text-[clamp(14px,1.3vw,25px)] leading-[1.6] text-center text-black max-w-[1000px] mx-auto">
            This initiative is brought to you by Greener Earth Foundation
            (non-profit) founded in 2022 by Aakash Ranison. Guided by a deep
            respect for nature, the environment-focussed organisation promotes
            sustainable living by transforming ideas into lasting change through
            education, advocacy, and action.
          </p>

          {/* Divider */}
          <div className="mt-20 sm:mt-28 md:mt-32 flex justify-center">
            <div className="w-[85%] sm:w-[75%] md:w-[680px] lg:w-[900px] xl:w-[1075px] h-px bg-black" />
          </div>

          {/* Creative Partners — Always 2x2 */}
          <div className="mt-14 mb-14 sm:mt-16 sm:mb-16 lg:mt-20 lg:mb-20">
            <div className="flex justify-center">
              <div className="w-full max-w-[1200px]">
                <div
                  className="
                    grid
                    grid-cols-2
                    lg:flex
                    lg:flex-nowrap
                    justify-center
                    items-center
                    gap-x-10
                    gap-y-10
                    sm:gap-x-16
                    sm:gap-y-12
                    lg:gap-24
                  "
                >
                  {/* Conscious Collective */}
                  <img
                    src="/logos/conscious-collective.png"
                    alt="Conscious Collective"
                    className="h-[36px] sm:h-[44px] lg:h-[58px] w-auto object-contain"
                  />

                  {/* Godrej & Boyce */}
                  <img
                    src="/logos/godrej-boyce.png"
                    alt="Godrej & Boyce"
                    className="h-[54px] sm:h-[70px] lg:h-[97px] w-auto object-contain"
                  />

                  {/* AAA Kind */}
                  <img
                    src="/logos/antkind.png"
                    alt="AAA Kind"
                    className="h-[36px] sm:h-[44px] lg:h-[58px] w-auto object-contain col-span-2 lg:col-span-1 justify-self-center"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom bar */}
      <div className="bg-[#1A3274] py-5 sm:py-6 lg:py-8">
        {/* Mobile & Tablet */}
        <div className="px-6 sm:px-8 lg:px-12 xl:px-[144px] max-w-[1400px] mx-auto lg:hidden">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <img
              src="/logos/logo-white.png"
              alt="Greener Earth"
              className="h-[30px] sm:h-[36px] w-auto object-contain"
            />
            <p className="font-inter text-[10px] sm:text-[11px] font-medium tracking-[0.05em] text-white uppercase text-center sm:text-right">
              ALL RIGHTS RESERVED | GREENER EARTH 2026
            </p>
          </div>
        </div>

        {/* Desktop */}
        <div className="hidden lg:block relative h-[80px] w-full">
          <img
            src="/logos/logo-white.png"
            alt="Greener Earth"
            className="absolute left-[40px] top-1/2 -translate-y-1/2 h-[40px] w-auto object-contain"
          />

          <p
            className="absolute font-inter font-medium text-white uppercase"
            style={{
              right: "14px",
              top: "50%",
              transform: "translateY(-50%)",
              fontSize: "15.66px",
              letterSpacing: "0.2em",
            }}
          >
            ALL RIGHTS RESERVED | GREENER EARTH 2026
          </p>
        </div>
      </div>
    </footer>
  );
}
